import React, { useState } from "react";
import PageHero from "../../components/PageHero";
import Pagination from "../../components/Pagination";
import { sorted } from "../../utils";

export default function Productions({ siteContent }) {
  const { headContent, image, title, productions, slug } = siteContent;

  const perPage = 6;
  const totalPages = Math.ceil(productions.length / perPage);
  const [page, setPage] = useState(1);

  const start = (page - 1) * perPage;
  const items = productions.slice(start, start + perPage);

  sorted(items, 'published')

  const renderName = (type) => {
    if (type === "anaisDeEvento") {
      return "Evento:"
    }
    if (type === "livro") {
      return "Organizador(es):"
    }
    return "Autores:"
  }

  const openProduction = (id) => {
    window.open(`/${slug}/${id}`, "_blank", "noopener,noreferrer");
  };

  return (
    <>
      <PageHero
        title={title}
        subtitle={headContent}
        img={image?.url}
      />

      <main className="container main">
        <section className="section">
          <div className="productionGrid">
            {items.map((a) => (
              <article key={a.id} className="acard">
                <button className="acard__media" onClick={() => openProduction(a.id)} type="button">
                  <img src={a.cover.url} alt={a.name} loading="lazy" />
                </button>

                <div className="acard__body">
                  <div className="acard__flex">
                    <div className="acard__meta">
                      <span>{a.published.split("-").reverse().join("-")}</span>
                    </div>
                    <div className="acard__meta">
                      {a.organizersOrAuthorsOrEvent && (
                        <>
                          <span>{renderName(a.type)} {a.organizersOrAuthorsOrEvent}</span>
                        </>
                      )}
                    </div>
                    <h3 className="acard__title">
                      <button className="linkBtn" onClick={() => openProduction(a.id)} type="button">
                        {a.name}
                      </button>
                    </h3>
                  </div>
                  <button className="btn btn--ghost" onClick={() => openProduction(a.id)} type="button">
                    LER DOCUMENTO
                  </button>
                </div>
              </article>
            ))}
          </div>

          <Pagination page={page} totalPages={totalPages} onChange={setPage} />
        </section>
      </main>
    </>
  );
}